module.exports = __webpack_public_path__ + "static/media/norton-secured.2bfe7ae2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/norton-secured.png
// module id = 1228
// module chunks = 1